import { createContext, useContext, type ReactNode } from "react";
import { useNativeSipCall } from "@/hooks/useNativeSipCall";

type NativeSipCallState = ReturnType<typeof useNativeSipCall>;

const NativeSipCallContext = createContext<NativeSipCallState | null>(null);

export function NativeSipCallProvider({ children }: { children: ReactNode }) {
  const state = useNativeSipCall();
  return <NativeSipCallContext.Provider value={state}>{children}</NativeSipCallContext.Provider>;
}

export function useNativeSipCallContext(): NativeSipCallState {
  const state = useContext(NativeSipCallContext);
  if (!state) throw new Error("useNativeSipCallContext must be used inside NativeSipCallProvider");
  return state;
}